import * as React from 'react'
import { ReactElement } from 'react'
import { useSelector } from 'react-redux'

import { BASE_URL_WITH_REACT } from '~config'

import { RootState } from '../redux/rootReducer'

import LoginScreen from './LoginScreen'

const Root = ({}): ReactElement | boolean => {
  const isAuthenticated = useSelector((state: RootState) => state?.auth.isAuthenticated)
  const isOutlookMode = useSelector((state: RootState) => state?.auth.isOutlookMode)

  if (isOutlookMode && isAuthenticated) {
    window.location.href = `${BASE_URL_WITH_REACT}/outlook/`
  }

  React.useEffect(() => {
    if (isAuthenticated) {
      window.location.href = `${BASE_URL_WITH_REACT}/cases/`
    }
  }, [])

  // How to handle constituents view?
  // if (!isAuthenticated && userId) {
  //   return <ConstituentCasesPage />
  // }

  return (
    !isAuthenticated && (
      <div className='app-container'>
        {' '}
        <LoginScreen />
      </div>
    )
  )
}

export default Root
